export default {
  title: 'Transferir Website',
  buttons: {
    cancel: 'Cancelar',
    transfer: 'Transferir',
  },
  fields: {
    target_franchise: {
      label: 'Franchise de Destino',
      description: 'Selecionar o franchise para o qual transferir o website',
    },
    sync_companies: {
      label: 'Mapeamentos de Empresa',
      description: 'Mapear empresas do franchise de destino para empresas da loja',
      franchise_company: 'Empresa do Franchise',
      storefront_company: 'Empresa da Loja',
      select_franchise_company: 'Selecionar empresa do franchise',
      select_storefront_company: 'Selecionar empresa da loja',
      franchise_company_required: 'A empresa do franchise é obrigatória',
      storefront_company_required: 'A empresa da loja é obrigatória',
    },
  },
  toasts: {
    failed_to_load_companies: 'Falha ao carregar empresas',
    no_companies_selected: 'Adicione pelo menos um mapeamento de empresa',
    failed_to_transfer: 'Falha ao transferir o website',
    transfer_success: 'Website transferido com sucesso',
    franchise_already_connected: 'O franchise de destino já está ligado a um website',
  },
};
